namespace GeniuzPOS.InitialData {
    export class IcWhsColumns {
        static columnsKey = 'InitialData.IcWhs';
    }
}
